import * as PricelistCurrentModels from '../../models/pricelist-current/pricelist-current';
import { PricelistCurrentSearchModel, PricelistOfferModel } from '../../models/pricelist-current/pricelist-currentSearch';


export class Get {
  static readonly type = '[PricelistCurrent] Get';
  constructor(public PricelistCurrentId: number) { }
}

export class Set {
  static readonly type = '[PricelistCurrent] Set';
  constructor(public PricelistCurrent: PricelistCurrentModels.PricelistCurrentModel) { }
}

export class GetList {
  static readonly type = '[PricelistCurrent] List';
  constructor(public Search: PricelistCurrentSearchModel) { }
}

export class ClearListPromoCode {
  static readonly type = '[PricelistCurrent] Clear List Promo Code';
  constructor(public ReportName: string, public Search: PricelistCurrentSearchModel) { }
}

export class SetSearch {
  static readonly type = '[PricelistCurrent] Set Search';
  constructor(public Search: PricelistCurrentSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[PricelistCurrent] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[PricelistCurrent] Set List Page';
  constructor(public Search: PricelistCurrentSearchModel) { }
}

export class Insert {
  static readonly type = '[PricelistCurrent] Insert';
  constructor(public PricelistCurrent: PricelistCurrentModels.PricelistCurrentModel) { }
}

export class ResetSave {
  static readonly type = '[PricelistCurrent] ResetSave';
  constructor() { }
}

export class SetMarkList {
  static readonly type = '[PricelistCurrent] SetMarkList';
  constructor(public AdditionalData: PricelistCurrentModels.PricelistCurrentModel[]) { }
}

export class GetOfferXLS {
  static readonly type = '[PricelistCurrent] GetOfferXLS';
  constructor(public AdditionalData: PricelistOfferModel) { }
}

export class GetOfferPDF {
  static readonly type = '[PricelistCurrent] GetOfferPDF';
  constructor(public AdditionalData: PricelistOfferModel) { }
}

export class SendOfferPDF {
  static readonly type = '[PricelistCurrent] SendOfferPDF';
  constructor(public AdditionalData: PricelistOfferModel) { }
}

export class GetReportFiltered {
  static readonly type = '[PricelistCurrent] GetReportFiltered';
  constructor(public search: PricelistCurrentSearchModel) { }
}

export class GetCustomerReportFiltered {
  static readonly type = '[PricelistCurrent] GetCustomerReportFiltered';
  constructor(public search: PricelistCurrentSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[PricelistCurrent] DisposeSearch';
  constructor() { }
}

export class ImportPromoCode {
  static readonly type = '[PricelistCurrent] ImportPromoCode';
  constructor(public ReportName: string, public FormData: FormData) { }
}
